import {FleetStatusBar} from '../components/fleet/FleetStatusBar'
import {SiteCard} from '../components/fleet/SiteCard'
import {ErrorState, LoadingState} from '../components/common/LoadingState'
import {usePortfolioState} from '../hooks/usePortfolioState'

export function Dashboard() {
  const query = usePortfolioState()
  if (query.isLoading) return <LoadingState label="Loading portfolio state" />
  if (query.isError || !query.data) return <ErrorState error={query.error} />
  const activeEvents = query.data.sites.filter((site) => site.status.active_event)
  return (
    <div className="page-stack">
      <div className="page-heading">
        <div>
          <span className="eyebrow">Portfolio operations</span>
          <h1>Fleet overview</h1>
        </div>
        <span className="poll-note">Portfolio polling: 60 seconds</span>
      </div>
      {activeEvents.length ? (
        <div className="active-events-banner">
          {activeEvents.length} site{activeEvents.length === 1 ? '' : 's'} in
          active dispatch: {activeEvents.map((site) => site.status.site_id).join(', ')}
        </div>
      ) : null}
      <FleetStatusBar dashboard={query.data} />
      <section>
        <div className="section-heading">
          <div>
            <span className="eyebrow">Site status</span>
            <h2>Portfolio sites</h2>
          </div>
          <span className="muted-copy">{query.data.sites.length} sites</span>
        </div>
        <div className="site-grid">
          {query.data.sites.map((site) => (
            <SiteCard key={site.status.site_id} {...site} />
          ))}
        </div>
      </section>
    </div>
  )
}
